import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const Register = loadable(() => pMinDelay(import('./Register'), 300), {
  fallback: <Loading />
});

const AsyncRegister = props =>{
  const pageConfig = {
    headerType: 'mobile-none',
    footerType: 'full',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <Register { ...props }/>
    </ApplicationLayout>
  );
};

AsyncRegister.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncRegister;
